import React from 'react'
import DropDown from '~/Common-Objects/UI/DropDowns/DropDown'
import Options from '~/assets/images/icons/options.svg'

export default class OptionsDropdown extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        return (
            <>
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        cursor: 'pointer'
                    }}
                    onClick={() => this.setState({ open: true })}
                >
                    <div className='table-icon'>
                        <img src={Options} width='16px' />
                    </div>
                </div>
                <DropDown
                    onClose={() => this.setState({ open: false })}
                    removeOnClose={this.props.removeOnClose}
                    align='right'
                    top={this.props.top || '45px'}
                    width={this.props.popWidth}
                    isOpen={this.state.open}
                >
                    {this.props.children}
                </DropDown>
            </>
        )
    }
}
